import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b335e3c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row header" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Welcome")
], -1))
const _hoisted_3 = {
  key: 0,
  class: "check-email"
}
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputEmail",
  class: "form-label"
}, " Please sign in with your email address: ", -1))
const _hoisted_6 = { class: "form-floating" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Email", -1))
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "border-secondary border-1" }, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Sign in ")
const _hoisted_12 = ["href"]
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" with limited access. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.sent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Thank you, please check your inbox and spam folder. "))
      : (_openBlock(), _createElementBlock("form", {
          key: 1,
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                type: "email",
                class: "form-control",
                id: "inputEmail",
                placeholder: "Email",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                disabled: _ctx.disabled
              }, null, 8, _hoisted_7), [
                [_vModelText, _ctx.email]
              ]),
              _hoisted_8
            ])
          ]),
          _createElementVNode("button", {
            class: "btn btn-primary",
            disabled: _ctx.disabled
          }, " Send an email link ", 8, _hoisted_9),
          _hoisted_10,
          _createElementVNode("div", null, [
            _hoisted_11,
            _createElementVNode("a", {
              href: _ctx.getAuthUrl('anon')
            }, "anonymously", 8, _hoisted_12),
            _hoisted_13
          ])
        ], 32))
  ]))
}